<ion-input
	[readonly]="dynamicFormControl.disabled"
	appDebounceKeyUpDirective
	[debounce]="isDebounceApplied ? 150 : 0"
	name="dynamicFormControl.key"
	[ngClass]="{
		'error-class':
			form.get(dynamicFormControl.key).invalid &&
			(form.get(dynamicFormControl.key).dirty || form.get(dynamicFormControl.key).touched),
		'disabled-class': dynamicFormControl.disabled
	}"
	[value]="fieldValue"
	[type]="dynamicFormControl.type"
	inputmode="decimal"
	(ionFocus)="updateFieldHasFocus()"
	(ionChange)="fieldValueChanged($event)"
></ion-input>
<ion-button
	*ngIf="!dynamicFormControl.disabled"
	[id]="dynamicFormControl.key"
	fill="clear"
	(click)="togglePositiveNegative($event)"
	[ngClass]="fieldHasFocus ? 'ion-no-margin button-visible' : 'ion-no-margin'"
	size="small"
>
	<ion-icon class="icon-Plus-Minus"></ion-icon>
</ion-button>
